/**
 * @external Lang
 */
import swal from 'sweetalert';

export default {
  confirmSettings(override = {}) {
    return Object.assign({
      title: Lang.get('form.confirm.changes'),
      text: Lang.get('form.confirm.changesText'),
      buttons: {
        confirm: {
          text: Lang.get('general.confirm'),
          value: true,
          visible: true,
          closeModal: true,
        },
        cancel: {
          text: Lang.get('general.cancel'),
          visible: true,
          closeModal: true,
        },
      },
    }, override);
  },
  target(selector) {
    const forms = document.querySelectorAll(selector);
    return {
      confirm: (override = {}) => {
        forms.forEach((form) => {
          form.swalSettings = this.confirmSettings(override);
          form.addEventListener('submit', this.onSubmit.bind(this))
        });
      },
    };
  },
  onSubmit(event) {
    event.preventDefault();
    swal(event.currentTarget.swalSettings).then((confirmed) => {
      if (confirmed) {
        event.target.submit();
      }
    });
  },
};
